var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedIncomeAssetsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.35 21C39.35 31.1344 31.1344 39.35 21 39.35C10.8656 39.35 2.65 31.1344 2.65 21C2.65 10.8656 10.8656 2.65 21 2.65C31.1344 2.65 39.35 10.8656 39.35 21ZM21 41.05C32.0733 41.05 41.05 32.0733 41.05 21C41.05 9.92669 32.0733 0.95 21 0.95C9.92669 0.95 0.95 9.92669 0.95 21C0.95 32.0733 9.92669 41.05 21 41.05Z",
    fill: "#28BF8C",
    stroke: "#28BF8C",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3296 13.9519C29.7154 14.274 29.7627 14.8496 29.4346 15.2303L19.5971 26.6447C19.2593 27.0365 18.6616 27.0637 18.2897 26.7041L12.6265 21.2283C12.2651 20.8789 12.26 20.3012 12.6151 19.9454L12.7023 19.8581C13.0495 19.5103 13.6115 19.5053 13.9648 19.8469L18.3129 24.0512C18.6022 24.3308 19.0671 24.3097 19.3297 24.0049L27.9744 13.9746C28.2953 13.6022 28.8556 13.5562 29.233 13.8712L29.3296 13.9519Z",
    fill: "#28BF8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIncomeAssetsSmall);
export default __webpack_public_path__ + "static/media/verified-income-assets-small.b0faf02d.svg";
export { ForwardRef as ReactComponent };